import React from 'react';

import PropTypes from 'prop-types';

import Confirm from 'components/Confirm';
import Message from 'components/Message';
import { intlMessage, reduxFormPropTypes } from 'constants/propTypes';
import { bem } from 'helpers/class-name';

// Reuse EmailModal CSS block/element names so styles apply without restyling.
// EmailModal.scss is always in the bundle alongside this modal.
import localMessages from './SkuCancelConfirmModal.messages';

const { block, element } = bem('email-modal');

// acceptMessage defaults to "Send" (out-of-stock flow).
// Pass dashboardMessages.cancelOrderNotifyButton for the partner-cancelled flow.
const SkuCancelConfirmModal = ({
  acceptMessage = localMessages.send,
  handleSubmit,
  submitting,
  title,
  to,
  subject,
  initialValues = {},
  ...rest
}) => {
  const message = initialValues.message || '';

  return (
    <Confirm
      className={block()}
      onConfirm={handleSubmit}
      title={title}
      cancelNode={<Message message={localMessages.cancel} />}
      acceptNode={<Message message={acceptMessage} />}
      acceptDisabled={submitting}
      acceptWaiting={submitting}
      {...rest}>
      <div className={element('section')}>
        <Message className={element('label')} as="div" message={localMessages.toLabel} />
        <span className={element('text')}>{to}</span>
      </div>
      <div className={element('section')}>
        <Message className={element('label')} as="div" message={localMessages.subjectLabel} />
        <span className={element('text')}>{subject}</span>
      </div>
      <div className={element('section')}>
        <Message className={element('label')} as="div" message={localMessages.messageLabel} />
        <div className={element('text')} dangerouslySetInnerHTML={{ __html: message }} />
      </div>
    </Confirm>
  );
};

SkuCancelConfirmModal.propTypes = {
  acceptMessage: intlMessage,
  handleSubmit: PropTypes.func.isRequired,
  subject: PropTypes.string.isRequired,
  submitting: PropTypes.bool,
  title: PropTypes.node.isRequired,
  to: PropTypes.string,
  ...reduxFormPropTypes.form,
};

export default SkuCancelConfirmModal;
